export default __webpack_public_path__ + "static/media/IMG6241.106138b4.jpg";